import useLiquidGlow from "../../hooks/useLiquidGlow";

/** Ambient section wash — card highlights are per-card via LiquidGlassCard. */
export default function LiquidGlassZone({
  className = "",
  children,
  as: Tag = "div",
}) {
  const { visible, onMove, onLeave, zoneRef } = useLiquidGlow();

  return (
    <Tag
      ref={zoneRef}
      className={`liquid-glass-zone ${className}`.trim()}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
    >
      <span className={`liquid-glass-glow ${visible ? "is-visible" : ""}`} aria-hidden="true" />
      {children}
    </Tag>
  );
}
